import React from "react";

const Avaluos_Form = () => {
  const handleSubmit = () => {};
  return (
    <div className="avaluos-form-container">
      <form onSubmit={handleSubmit}>
        <input type="text"></input>
        <input type="submit">Enviar</input>
      </form>
    </div>
  );
};

export default Avaluos_Form;
